// extracted by mini-css-extract-plugin
export default {"title":"BussinessAddress_title__wcQEs","description":"BussinessAddress_description__9kEJO","modalTitle":"BussinessAddress_modalTitle__Sny9p"};